import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import ActionReserve from '../../graphql/mutations/ActionReserve';
import ActionCancelReservation from '../../graphql/mutations/ActionCancelReservation';
import CollectionItemModal from './CollectionItemModal';
import ActionHold from '../../graphql/mutations/ActionHold';
import ActionCancelHold from '../../graphql/mutations/ActionCancelHold';
import {useTranslation} from "react-i18next";
import {decorateStates} from "../../helpers/decorators/StateDecorator";

import './CollectionStyles.scss';

const CollectionItem = ({ dbId, onUpdateEntity, isReserved, isReservedMe, isBorrowed, isBorrowedMe, isHolded, isHoldedMe,
                            states, entity,
                            imageUrl, title, author, publisher, copies, availability, description }) => {
    const [openReadMore, setOpenReadMore] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openReserve, setOpenReserve] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const toErrorMessage = (err) => Array.isArray(err) ? err.join(', ') : (err || '').toString();

    const maybeRedirectToSubscription = (message) => {
        const s = (message || '').toLowerCase();
        if (s.includes('is not active') || s.includes('не активна')) {
            navigate('/account/subscription');
            return true;
        }
        return false;
    };

    const redirectToSignIn = () => {

        if(!localStorage.getItem('authToken')) {
            navigate('/sign-in');

            toast.error('Please sign in or register!');

            setIsLoading(false);

            return true;
        }

        return false;
    }
    const handleOpenReadMore = () => setOpenReadMore(true);
    const handleCloseReadMore = () => setOpenReadMore(false);

    const handleOpenReserve = () => setOpenReserve(true);
    const handleCloseReserve = () => setOpenReserve(false);

    const handleCancelHold = () => {
        setIsLoading(true);

        if (redirectToSignIn()) {
            return
        }
        try {
            ActionCancelHold.commit({ id: entity.dbId }).then(({ actionCancelHold }) => {
                const { error, entity } = actionCancelHold;

                if (error.length > 0) {
                    toast.error(error);
                } else {
                    onUpdateEntity(entity);
                    toast.success(`Reservation of ${title} Cancelled`);
                }

                toast.success(`Hold of ${title} Cancelled`);
                handleCloseReserve();
                setIsLoading(false);
            });
        } catch (err) {
            setIsLoading(false);
            console.error('Sign-up error:', err);
            toast.error('An unexpected error occurred.');
        }
    };

    const handleCancelReserve = () => {
        setIsLoading(true);

        if (redirectToSignIn()) {
            return
        }
        try {
            ActionCancelReservation.commit({ id: entity.dbId }).then(({ actionCancelReservation }) => {
                const { error, entity } = actionCancelReservation;

                if (error.length > 0) {
                  toast.error(error);
                } else {
                  onUpdateEntity(entity);
                  toast.success(`Reservation of ${title} Cancelled`);
                }
                handleCloseReserve();
                setIsLoading(false);
            });
        } catch (err) {
            setIsLoading(false);
            console.error('Sign-up error:', err);
            toast.error('An unexpected error occurred.');
        }
    };

    const handleHold = () => {
        setIsLoading(true);

        if (redirectToSignIn()) {
            return
        }
        try {
            ActionHold.commit({ id: entity.dbId }).then(({ actionHold }) => {
                const { error, entity } = actionHold;

                if (error) {
                    const msg = toErrorMessage(error);
                    toast.error(msg);
                    maybeRedirectToSubscription(msg);
                } else {
                    onUpdateEntity(entity);
                    toast.success(`${title} Put on Hold`);
                    handleCloseReserve();
                    // window.location.reload(true);
                }

                setIsLoading(false);
            });
        } catch (err) {
            console.error('Sign-up error:', err);
            setIsLoading(false);
            toast.error('An unexpected error occurred.');
        }
    };

    const handleReserve = () => {
        setIsLoading(true);

        if (redirectToSignIn()) {
            return
        }

        try {
            ActionReserve.commit({ id: entity.dbId }).then(({ actionReserve }) => {
                const { error, entity } = actionReserve;

                if (error) {
                    const msg = toErrorMessage(error);
                    toast.error(msg);
                    maybeRedirectToSubscription(msg);
                } else {
                    onUpdateEntity(entity);
                    toast.success(`${title} Reserved`);
                    handleCloseReserve();
                    // window.location.reload(true);
                }
                setIsLoading(false);
            });
        } catch (err) {
            setIsLoading(false);
            console.error('Sign-up error:', err);
            toast.error('An unexpected error occurred.');
        }
    };

    return (
        <Box className="collection-item">
            <Box onClick={handleOpenReserve}>
                {/* Front Side */}
                <Box>
                    {imageUrl ? (
                        <img src={imageUrl} alt={title} className="item-image" />
                    ) : (
                        <Box
                            className="item-image"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            style={{
                                height: '150px',
                                backgroundColor: '#eceff1',
                                borderRadius: '8px',
                            }}
                        >
                            <BookOutlinedIcon fontSize="large" />
                        </Box>
                    )}
                    <Box className="item-content">
                        <Typography variant="h6" className="truncate item-title">
                            {title}
                        </Typography>
                        {author?.length > 2 && (<Typography variant="body2" className="truncate item-author">
                            Author: {author}
                        </Typography>)}
                        {/*<Typography variant="body2" className="item-publisher">*/}
                        {/*    Publisher: {publisher}*/}
                        {/*</Typography>*/}
                        {localStorage.getItem('authToken') &&
                          (
                            <Typography
                            variant="body2"
                            className={`item-availability ${states.toLowerCase()}`}
                            >
                            {t(`catalog.item.status.${decorateStates({ states, isReservedMe, isBorrowedMe, isHoldedMe })}`)}
                            </Typography>
                       )}
                    </Box>
                </Box>

                {/* Back Side */}
                <Box className="flip-card-back">
                    <Typography variant="body2" className="additional-info">
                        {description?.length > 100 ? `${description.slice(0, 100)}...` : description}
                    </Typography>
                    <Box className="action-buttons">
                        <Button
                            className="action-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenReserve();
                            }}
                            variant="outlined"
                        >
                            {t('catalog.item.details')}
                        </Button>
                    </Box>
                </Box>
            </Box>

            {/* Read More Modal */}
            <Dialog
                fullScreen
                open={openReadMore}
                onClose={handleCloseReadMore}
                aria-labelledby="read-more-title"
            >
                <DialogTitle id="read-more-title">{title}</DialogTitle>
                <DialogContent>
                    {author?.length > 2 && <Typography variant="h6" className="truncate">Author: {author}</Typography> }
                    {publisher?.length > 1 && <Typography variant="h6" className="truncate">Publisher: {publisher}</Typography> }
                    <Typography variant="h6" className="truncate">Copies: {copies}</Typography>
                    <Typography variant="body1" style={{ marginTop: '16px' }}>
                        {description || 'Some short book description. Some short book description. '}
                    </Typography>
                    <Button onClick={handleCloseReadMore} variant="outlined" style={{ marginTop: '16px' }}>
                        {t('close')}
                    </Button>
                </DialogContent>
            </Dialog>

            {/* Reserve Modal */}
            <CollectionItemModal
                isLoading={isLoading}
                title={title}
                description={description}
                author={author}
                publisher={publisher}
                imageUrl={imageUrl}
                openReserve={openReserve}
                availability={availability}
                states={states}
                handleCloseReserve={handleCloseReserve}
                handleCancelReserve={handleCancelReserve}
                handleReserve={handleReserve}
                handleHold={handleHold}
                handleCancelHold={handleCancelHold}
                isBorrowedMe={isBorrowedMe}
                isBorrowed={isBorrowed}
                isHolded={isHolded}
                isHoldedMe={isHoldedMe}
                isReserved={isReserved}
                isReservedMe={isReservedMe}
            />
        </Box>
    );
};

export default CollectionItem;
